export default __webpack_public_path__ + "static/media/baysel2.12c3bb39.png";